import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class PreviousRouteService {

  private PreviousUrl: string;
  private CurrentUrl: string;

  constructor(private router: Router) {
    this.CurrentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {        
        this.PreviousUrl = this.CurrentUrl;
        this.CurrentUrl = event.url;
      };
    });
  }

  public GetPreviousUrl() {
    return this.PreviousUrl;
  }    
}